interface FaqItem {
  q: string;
  a: string;
}

const faqs: FaqItem[] = [
  {
    q: '91樱花最新网址是什么？',
    a: '91樱花最新网址会在本页Hero区域及实时快讯模块中第一时间更新。由于域名可能受网络环境影响发生变动，建议收藏当前页面，我们会实时同步最新可用地址，确保你随时都能访问动漫内容。',
  },
  {
    q: '为什么有时候无法访问91樱花？',
    a: '动漫资源站点偶尔会遇到域名解析波动或网络限制。我们为此建立了多线路备用机制，当主域名暂时不可用时，你可以通过页面内提供的备用入口继续访问。同时建议关注实时快讯模块获取最新地址更新通知。',
  },
  {
    q: '91樱花需要注册账号吗？',
    a: '91樱花支持免注册直接浏览和观看动漫内容。注册账号可以解锁收藏夹同步、追番进度跨设备同步、评论互动等高级功能，但不是必需的，核心观影功能完全免费开放。',
  },
  {
    q: '91樱花的动漫画质如何？',
    a: '我们提供从720P到1080P+的高清画质选项，部分热门作品还支持更高画质。所有视频经过优化压缩，在保证清晰度的同时尽可能降低带宽消耗，让你在网络条件一般的情况下也能流畅观看。',
  },
  {
    q: '如何将91樱花添加到手机桌面？',
    a: '在浏览器中打开91樱花后，使用Safari（iOS）或Chrome（Android）的"添加到主屏幕"功能，即可像App一样快捷访问。添加到桌面后还支持推送通知，第一时间获取最新地址更新提醒。',
  },
  {
    q: '91樱花更新新番的速度有多快？',
    a: '91樱花与各大字幕组保持紧密合作，新番通常在播出后数小时内完成上线。热门作品的更新速度更快，部分甚至可以做到同步更新，让你不必担心错过每一集精彩内容。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">常见问题</h2>
          <p className="text-sm text-foreground-500">关于91樱花使用与访问的常见疑问解答</p>
        </div>

        <div className="flex flex-col gap-4">
          {faqs.map((item, idx) => (
            <div key={idx} className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70">
              <h3 className="font-heading text-base md:text-lg text-foreground-900 mb-3">
                <span className="text-primary-500 mr-2">Q{idx + 1}.</span>
                {item.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-6">{item.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}